import { faAngleDown, faBoxAlt, faBoxes } from '@fortawesome/pro-regular-svg-icons'
import { Box, Button, Flex, Menu } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

type ButtonNewProductProps = {
  disabled: boolean
  handleCreateItem: () => void
  handleCreateBundle: () => void
}

export function ButtonNewProduct({
  disabled,
  handleCreateItem,
  handleCreateBundle,
}: ButtonNewProductProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'items' })

  return (
    <Menu withinPortal>
      <Menu.Target>
        <Button
          data-cy='add-new-item'
          data-testid='btn-new-product'
          variant='filled'
          disabled={disabled}
        >
          <Flex align='center' gap='xs'>
            <Box>{t('add_item_label')}</Box>
            <Icon icon={faAngleDown} />
          </Flex>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          c='gray.8'
          leftSection={<Icon icon={faBoxAlt} />}
          variant='transparent'
          onClick={handleCreateItem}
        >
          {t('add_item_label_dropdown')}
        </Menu.Item>
        <Menu.Item
          c='gray.8'
          leftSection={<Icon icon={faBoxes} />}
          variant='transparent'
          onClick={handleCreateBundle}
        >
          {t('add_bundle_label_dropdown')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
